"use client"

import { useEffect } from "react"
import { useLocation } from "react-router-dom"

function scrollToHash(hash: string) {
  const id = hash.replace(/^#/, "")
  if (!id) return false
  const el = document.getElementById(id)
  if (!el) return false
  el.scrollIntoView({ behavior: "smooth", block: "start" })
  return true
}

/** Scroll to top on route change; honour hash anchors like /#agents. */
export function MarketingScroll() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      let attempts = 0
      const tryScroll = () => {
        if (scrollToHash(hash) || attempts >= 12) return
        attempts += 1
        requestAnimationFrame(tryScroll)
      }
      tryScroll()
      return
    }

    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
